import type { Interaction, InteractionRecipient } from "./types";

export type ShareInteractionPreviewInput = {
  interaction: {
    id: string;
    description: string;
    owner: string;
    date: string | Date;
    mode: string;
    topic: string;
    participants: string[];
  };
  recipients: Array<{ name: string; email: string }>;
  notes?: string | null;
  pgaId: string;
};

export function buildShareInteractionInput({
  interaction,
  recipients,
  notes,
  pgaId,
  includeRelatedToInParticipants = false
}: {
  interaction: Interaction;
  recipients: InteractionRecipient[];
  notes?: string;
  pgaId: string;
  includeRelatedToInParticipants?: boolean;
}): ShareInteractionPreviewInput {
  const participantNames = interaction.participants.map(
    (participant) => `${participant.firstName} ${participant.lastName}`
  );
  const participants =
    includeRelatedToInParticipants && interaction.relatedTo
      ? [interaction.relatedTo, ...participantNames]
      : participantNames;

  return {
    interaction: {
      id: interaction.id,
      description: interaction.lastMessage.content,
      owner: interaction.owner?.name ?? "",
      date: interaction.interactionDate,
      mode: interaction.mode,
      topic: interaction.categories[0] ?? "",
      participants
    },
    recipients: recipients.map((recipient) => ({
      name: recipient.name,
      email: recipient.email
    })),
    notes: notes ?? null,
    pgaId
  };
}

export const buildShareInteractionPreviewInput = buildShareInteractionInput;
